
export const isVariableProductType = (productType: unknown): boolean => {
  if (productType == null) return false;
  if (typeof productType === "boolean") return productType;
  if (typeof productType === "number") return productType === 1;
  return String(productType).trim().toLowerCase() === "variable";
};

export const extractCategoryId = (product: any): number => {
  const raw = product?.categoryId ?? product?.category?.categoryId ?? product?.category_id ?? 0;
  const num = Number(raw);
  return Number.isFinite(num) ? num : 0;
};

export const buildOptionValueLookup = (
  categoryVariantSection: Record<string, Array<any>>
): Record<number, string> => {
  const lookup: Record<number, string> = {};
  Object.values(categoryVariantSection || {}).forEach((list: any) => {
    (Array.isArray(list) ? list : []).forEach((opt: any) => {
      if (opt?.categoryVariantOptionId != null) {
        lookup[opt.categoryVariantOptionId] = opt.optionValue;
      }
    });
  });
  return lookup;
};

export const buildSkuCombo = (
  sku: any,
  optionValueLookup: Record<number, string>
): string => {
  const combo = (sku?.productSkuOptionsList || [])
    .map((o: any) => optionValueLookup[o.categoryVariantOptionId] || o.optionValue)
    .filter(Boolean)
    .join(" / ");
  return combo || "-";
};
